import { NAV_CITIES } from "./nav-items";

/**
 * Geographic neighbours for each city landing page. Used to build a tight
 * internal-link cluster between towns that people actually search together.
 */
const NEARBY: Record<string, string[]> = {
  Albany: ["Colonie", "Delmar", "Guilderland", "Loudonville"],
  Schenectady: ["Niskayuna", "Guilderland", "Altamont", "Colonie"],
  "Saratoga Springs": ["Ballston Spa", "Clifton Park", "Halfmoon", "Troy"],
  Troy: ["Rensselaer", "East Greenbush", "Latham", "Menands"],
  "Clifton Park": ["Halfmoon", "Ballston Spa", "Latham", "Saratoga Springs"],
  Rensselaer: ["East Greenbush", "Troy", "Albany", "Glenmont"],
  Colonie: ["Latham", "Loudonville", "Albany", "Menands"],
  Latham: ["Colonie", "Loudonville", "Halfmoon", "Troy"],
  Guilderland: ["Altamont", "Albany", "Schenectady", "Delmar"],
  Delmar: ["Glenmont", "Bethlehem", "Albany", "Slingerlands"],
  Niskayuna: ["Schenectady", "Colonie", "Latham", "Albany"],
  "Ballston Spa": ["Saratoga Springs", "Clifton Park", "Halfmoon", "Schenectady"],
  Altamont: ["Guilderland", "Schenectady", "Albany", "Delmar"],
  Bethlehem: ["Delmar", "Glenmont", "Ravena", "Albany"],
  Loudonville: ["Colonie", "Latham", "Menands", "Albany"],
  Menands: ["Loudonville", "Albany", "Troy", "Colonie"],
  Halfmoon: ["Clifton Park", "Latham", "Ballston Spa", "Saratoga Springs"],
  "East Greenbush": ["Rensselaer", "Troy", "Albany", "Glenmont"],
  Glenmont: ["Delmar", "Bethlehem", "Albany", "Ravena"],
  Ravena: ["Glenmont", "Bethlehem", "Delmar", "Albany"],
};

export function getNearbyCities(city: string, limit = 4) {
  const wanted = NEARBY[city] ?? [];
  return resolveNearby(city, wanted, limit);
}

/** Raw neighbour town names for a city (no slug resolution). */
export function getNearbyCityNames(city: string) {
  return NEARBY[city] ?? [];
}

function resolveNearby(city: string, wanted: string[], limit: number) {
  const byName = new Map(NAV_CITIES.map((c) => [c.city, c]));
  const picked = wanted
    .map((name) => byName.get(name))
    .filter((c): c is { slug: string; city: string } => Boolean(c) && c!.city !== city);
  if (picked.length < limit) {
    for (const c of NAV_CITIES) {
      if (c.city === city || picked.some((p) => p.city === c.city)) continue;
      picked.push(c);
      if (picked.length >= limit) break;
    }
  }
  return picked.slice(0, limit);
}
